import { store } from '../store';
import { OPEN, CLOSE } from './modal-types';
import { ModalOptions } from './modal-state.interface';

export const showModal = (
    id: string,
    option?: ModalOptions,
    onClose?: () => void,
    onTrueAction?: () => void,
    onFalseAction?: () => void
) => {
    store().dispatch({
        type: OPEN,
        payload: {
            id,
            show: true,
            onClose,
            option,
            onTrueAction,
            onFalseAction,
        },
    });
};

export const hideModal = (id: string) => {
    store().dispatch({
        type: CLOSE,
        payload: {
            id,
            show: false,
        },
    });
};
